/** Stockage en mémoire — utilisé par les tests et par le rendu hors navigateur. */
export function memoryRefreshTokenStore(initial = null) {
    let token = initial;
    return {
        read: () => token,
        write: (value) => {
            token = value;
        },
        clear: () => {
            token = null;
        },
    };
}
/** Stockage local du navigateur, tolérant à son indisponibilité (navigation privée). */
export function browserRefreshTokenStore(key = 'repere.refresh') {
    return {
        read: () => {
            try {
                return globalThis.localStorage?.getItem(key) ?? null;
            }
            catch {
                return null;
            }
        },
        write: (value) => {
            try {
                globalThis.localStorage?.setItem(key, value);
            }
            catch {
                /* stockage indisponible : la session ne survivra pas au rechargement */
            }
        },
        clear: () => {
            try {
                globalThis.localStorage?.removeItem(key);
            }
            catch {
                /* rien à nettoyer */
            }
        },
    };
}
//# sourceMappingURL=tokens.js.map